import React from "react";
import { Select } from "./Select";

// Barres de filtres de tous les tableaux : le style de Produits, au format compact
// des historiques (32 px de haut, texte `sm`).

export const FILTER_LABEL = "flex flex-col gap-1 text-sm";

export const FILTER_CONTROL =
  "h-8 px-3 text-sm bg-white rounded-lg border border-grey-medium text-default-text";

const BUTTON =
  "h-8 px-4 rounded-lg font-oxaniumMedium text-sm uppercase tracking-wider transition-opacity hover:opacity-90";

export const FILTER_BUTTON_PRIMARY = `${BUTTON} bg-secondary text-secondary-text`;

export const FILTER_BUTTON_SECONDARY = `${BUTTON} bg-white border border-grey-medium text-default-text`;

export const FilterSelect = (props: React.ComponentProps<typeof Select>) => (
  <Select {...props} size="compact" />
);
